import AbstractGuestlistDetailsPageController from '../abstract-details-controller';

export default class GuestlistWalletTicketPageController extends AbstractGuestlistDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.cancelTrigger = false;
        this.showEditor = false;
    }

    $onInit() {
        super.$onInit();

        this.routeOutCheckDestruct = this.injector.get('$transitions').onBefore(
            {},
            trans => {
                return new Promise((resolve, reject) => {
                    if (!_.isFunction(this.cancelTrigger)) {
                        resolve(trans);
                        return;
                    }

                    this.cancelTrigger()
                        .then(() => {
                            resolve(trans);
                        })
                        .catch(() => {
                            resolve(false);
                        })
                });
            });

        this.scope.$on('$destroy', () => {
            if (_.isFunction(this.routeOutCheckDestruct)) {
                this.routeOutCheckDestruct();
            }
        });
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        this.showEditor = !!this.guestlist.passbook_id;
    }

    handleCancel() {
        this.reloadEditor();
    }

    handleSaveSuccess() {
        this.reloadEditor();
    }

    reloadEditor() {
        this.showEditor = false;
        this.scope.$applyAsync();

        this.injector
            .get('$timeout')(
                () => {
                    this.showEditor = true;
                },
                100
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/tickets/wallet-ticket-controller.js